// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

Vue.filter('numeric', function (value) {
  if (value || value === 0) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
})

window.config = {
  apiUrl: 'http://157.230.43.193/restoku-api/api'
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js